import React from 'react'
import {graphql} from 'gatsby'
import Home from '../components/page/home'

import Layout from '../containers/layout'
import SEO from '../components/seo'

export const query = graphql`
  query sanityHome {
    sanityHome {
      title
      videoID
      slideshow {
        slides {
          _key
          title
          link
          slideImage {
            asset {
              fluid(maxWidth:1900) {
                ...GatsbySanityImageFluid
              }
            }
          }
        }
      }
      seoSettings {
        title
        description
        openGraphImage {
          asset {
            url
          }
        }
      }
    }
  }
`

const PagePage = ({data: {sanityHome: page}}) => (
  <Layout title={page.title}>
    {page.seoSettings && page.seoSettings.title && page.seoSettings.description && (
      <SEO title={page.seoSettings.title} description={page.seoSettings.description} openGraphImage={page.seoSettings.openGraphImage ? page.seoSettings.openGraphImage.asset.url : null} />
    )}
    <Home slideshow={page.slideshow} videoID={page.videoID} />
  </Layout>
)

export default PagePage
